import { StandardEvents } from '@shopify/events';

class CollectionPromoBar extends HTMLElement {
  #abort;
  #refreshVersion = 0;
  #feedbackTimer;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate, { signal });
    window.addEventListener('pageshow', this.#onPageShow, { signal });
    this.addEventListener('click', this.#openCart, { signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
    clearTimeout(this.#feedbackTimer);
    this.#refreshVersion++;
  }

  #onPageShow = (event) => {
    if (event.persisted) this.#refresh();
  };

  #openCart = async (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.rc-bundle-bar__button')) return;
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    await customElements.whenDefined('cart-drawer-component');
    drawer.open();
  };

  #onCartUpdate = (event) => {
    this.setAttribute('data-updating', '');
    event.promise?.then(({ detail }) => {
      if (!detail?.didError) return this.#refresh(event.action === 'add');
    }).catch(() => {}).finally(() => this.removeAttribute('data-updating'));
  };

  async #refresh(added = false) {
    const version = ++this.#refreshVersion;
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.#abort.signal });
      if (!response.ok) throw new Error('Unable to update promotion');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('.rc-bundle-bar__content');
      if (version !== this.#refreshVersion || !content || !this.isConnected) return;
      this.querySelector('.rc-bundle-bar__content')?.replaceWith(content);
      const rail = this.querySelector('.rc-bundle-bar__slots');
      const latest = [...(rail?.querySelectorAll('.is-filled') || [])].at(-1);
      if (rail && latest) rail.scrollLeft = Math.max(0, latest.offsetLeft - rail.offsetLeft - rail.clientWidth + latest.offsetWidth);
      if (added) {
        this.setAttribute('data-added', '');
        clearTimeout(this.#feedbackTimer);
        this.#feedbackTimer = setTimeout(() => this.removeAttribute('data-added'), 1200);
      }
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[collection-promo]', error);
    }
  }
}

if (!customElements.get('rc-collection-promo-bar')) customElements.define('rc-collection-promo-bar', CollectionPromoBar);

